export var ChatPaneName;
(function (ChatPaneName) {
    ChatPaneName["search"] = "search";
    ChatPaneName["media"] = "media";
})(ChatPaneName || (ChatPaneName = {}));
